<template>
  <div>
    <div class="action d-flex justify-end">
      <v-tooltip bottom v-if="$auth.policies['update-note-period']">
        <template v-slot:activator="{ on, attrs }">
          <div class="button-note">
            <v-btn icon @click="openNoteDialog" v-bind="attrs" v-on="on">
              <v-icon>mdi-file-document-edit</v-icon>
            </v-btn>
            <div v-if="report.isUseNote" class="noti-note"></div>
          </div>
        </template>
        <span class="white--text">Bổ sung ghi chú</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="openHistoryDialog" v-bind="attrs" v-on="on">
            <v-icon>mdi-history</v-icon>
          </v-btn>
        </template>
        <span class="white--text">Lịch sử đối soát</span>
      </v-tooltip>
      <v-tooltip v-if="viewIsPaid" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="!isPaid" icon @click="updateStatus" v-bind="attrs" v-on="on">
            <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          </v-btn>
          <v-btn v-else icon @click="updateStatus" v-bind="attrs" v-on="on">
            <img :src="InfomationOffIcon" />
          </v-btn>
        </template>
        <span class="white--text">{{ !isPaid ? 'Đã thu' : 'Chưa thu' }}</span>
      </v-tooltip>
    </div>
    <EditNotePeriod ref="edit-note" />
    <PopupHistory ref="popup-history" />
  </div>
</template>
<script>
import EditNotePeriod from './EditNotePeriod.vue'
import PopupHistory from './PopupHistory.vue'
import InfomationOffIcon from '@/assets/collect.svg'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    EditNotePeriod,
    PopupHistory,
  },
  props: {
    report: Object,
    viewIsPaid: Boolean,
    isPaid: Boolean,
  },
  data() {
    return {
      isEditNote: false,
      isOpenDialog: false,
      InfomationOffIcon,
    }
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
    }),
  },
  methods: {
    ...mapActions({
      setReport: 'tuitionFeeReport/setReport',
      editStatusPaid: 'tuitionFeeReport/editStatusPaid',
    }),
    openNoteDialog() {
      this.setReport(this.report)
      this.$refs['edit-note'].openDialog()
    },
    openHistoryDialog() {
      this.setReport(this.report)
      this.$refs['popup-history'].openDialog()
    },
    updateStatus() {
      this.$dialog.confirm({
        title: 'Xác nhận cập nhật trạng thái?',
        text: `<p style=" margin-bottom: 0px;">Thay đổi trạng thái thanh toán thành ${
          this.isPaid ? '<span class="red--text">Chưa thu<span>' : '<span class="success--text">Đã thu<span>'
        } sẽ ảnh hưởng đến tổng số tiền đã thu.</p><span>Bạn có muốn tiếp tục?</span>`,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            const params = {
              id: this.report.id,
            }
            params.isPaid = !this.isPaid
            if (params.isPaid == true) params.feeStatus = 'correct'
            if (params.isPaid == false) params.feeStatus = 'under'

            await this.editStatusPaid(params)
            this.$alert.success('Đã cập nhật thành công!')
          } catch (e) {
            this.$alert.error({ title: 'Lỗi kết nối', description: 'Không thể cập nhật. Vui lòng thử lại' })
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.action {
  min-width: 70px;
}
.old-action {
  min-width: 108px;
}
.button-note {
  position: relative;
  .noti-note {
    position: absolute;
    left: 6px;
    top: 5px;
    background-color: red;
    width: 8px;
    height: 8px;
    border-radius: 10px;
  }
}
</style>
